<template>
  <div class="col-lg-12">
    <div class="brand-card tamanho-fora">
      <div class="brand-card-header bg-white tamanho-dentro">
        <img
          class="navbar-brand-full"
          v-bind:src="logo300x300"
          v-if="logo300x300"
          width="auto"
          height="60"
          v-bind:alt="whitelabelName + ' Logo'"
        />
      </div>
      <div class="brand-card-body bg-info tamanho-dentro">
        <div>
          <div class="text-uppercase" v-if="subscription && (subscription.status == 0 || subscription.status == 2)">
            <span class="badge badge-danger">
              <h5>{{subscription.status === 0 || subscription.status === 2 ? "CONTA FREE" : "CONTA EXPIRADA" }}</h5>
            </span>
          </div>
          <div class="text-uppercase" v-if="subscription && (subscription.status == 1 || subscription.status == 3)">
            <span class="badge badge-info">
              <h5>CONTA {{(me && me.subscription && me.subscription.planType == 'VIP') ? 'VIP' : 'PREMIUM'}}</h5>
            </span>
          </div>
          <div
            class="text-value"
            v-if="subscription && (subscription.status == 0 || subscription.status == 3 || (subscription.status == 2 && subscription.credits)) && !subscription.isExpired"
          >Sua conta irá expirar em {{subscription.due | moment("DD/MM/YYYY")}} às {{subscription.due | moment("HH:mm")}}. Até lá você pode fazer no máximo {{subscription.credits}} downloads.</div>
          <div
            class="text-value" style="font-size: 13pt;"
            v-if="subscription && subscription.isExpired && (subscription.status == 1 || subscription.status == 2 || subscription.status == 3)"
          > Sua assinatura expirou em: <b>{{subscription.due | moment("DD/MM/YYYY")}}</b> às <b>{{subscription.due | moment("HH:mm")}}</b></div> 
          <div v-if="!subscription.isExpired && subscription.recurrent && !canceledSubscription"> <b-button @click="cancelSubscription" variant="danger">Cancelar Assinatura</b-button> </div>
          <div v-if="canceledSubscription">Solicitação recebida. Sua assinatura será cancelada.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../service";

export default {
  name: "subscription-box",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    },
    subscription: {}
  },
  data: () => {
    return {
      currentPage: 1,
      canceledSubscription: false,
      fields: {
        due: {
          label: "Vencimento"
        },
        status: {
          label: "Status"
        }
      }
    };
  },
  computed: {
    items: function() {
      return [this.subscription];
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    logo300x300() {
      return localStorage.logo300x300;
    }
  },
  methods: {
    getSubscriptionBadge(subscriptionStatus) {
      return subscriptionStatus === 0
        ? "primary"
        : subscriptionStatus === 1
        ? "success"
        : subscriptionStatus === 2
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    cancelSubscription: function() {
      service.cancelSubscription().then(
        response => {
          this.canceledSubscription = true;
        },
        () => {
          this.showError = true;
        }
      );
    }
  }
};
</script>


<style>
.tamanho-fora {
  height: 415px !important;
}
.tamanho-dentro {
  height: 210px !important;
}
</style>


